import API from "./api.js";
import store from "../store/index.js";

function saveConfig(payload, messages, subscribers, misc, motd, hypetrain, custom, goals, charity) {
  const { channelId } = store.state;

  if (!channelId) {
    throw new Error("Missing required data for fetching initial state.");
  }

  const url = `/channel/${channelId}`;
  return API.post(url, {
    followers: {
      target: parseInt(payload.fTarget.replace(/,/g, ''), 10),
      message: payload.fMessage,
      gauge_colour: payload.fGaugeColour,
      display_recent_followers: payload.fDisplay
    },
    messages: {
      target: parseInt(messages.target.replace(/,/g, ''), 10),
      gauge_colour: messages.gaugeColour,
      enabled: messages.enabled
    },
    panel_settings: {
      background_colour: payload.pBkgColour,
      font_colour: payload.pFontColour,
      dark_mode: payload.fDarkMode,
    },
    subscribers: {
      target: parseInt(subscribers.target.replace(/,/g, ''), 10),
      gauge_colour: subscribers.gaugeColour
    },
    misc,
    motd: {
      msg: motd.msg,
      ts: parseInt(motd.ts)
    },
    hypetrain: {
      gauge_colour: hypetrain.gaugeColour
    },
    custom: {
      gauge_colour: custom.gaugeColour,
      title: custom.title,
      target: parseInt(custom.target.replace(/,/g, ''), 10),
      count: parseInt(custom.count.replace(/,/g, ''), 10),
      enabled: custom.enabled,
      img: custom.img,
      subButtonEnabled: custom.subButtonEnabled
    },
    goals: {
      gauge_colour: goals.gaugeColour,
    },
    charity: {
      gauge_colour: charity.gaugeColour,
    }
  });
}

function getUsername() {
  var config = window.Twitch.ext.configuration;

  if (config.developer) {
    var developer = JSON.parse(config.developer.content);
    return developer.username;
  }

  if (config.global) {
    var broadcaster = JSON.parse(config.global.content);
    return broadcaster.followers.goal;
  }

  return "";
}

function getGlobalConfig() {
  var config = window.Twitch.ext.configuration;

  if (config.global) {
    var global = JSON.parse(config.global.content);
    return global;
  }

  return {};
}

function getDeveloperConfig() {
  var config = window.Twitch.ext.configuration;

  if (config.broadcaster) {
    var developer = JSON.parse(config.developer.content);
    return developer;
  }

  return {};
}

function getBroadcasterConfig() {
  var config = window.Twitch.ext.configuration;

  if (config.broadcaster) {
    var broadcaster = JSON.parse(config.broadcaster.content);
    return broadcaster;
  }

  return {};
}

export default {
  getUsername,
  getBroadcasterConfig,
  getDeveloperConfig,
  getGlobalConfig,
  saveConfig
};
